import { Alert, AlertText } from '@mercell/alert-react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

const HTML_COMPONENT_TAG = /<\/?(?:strong|br)\b/i;

export const InformationBoxComponent = (props: any) => {
    const change = props.input.value;
    const { t } = useTranslation('form-content');

    const placeholderValue = change ? t(change) : undefined;
    const i18nKey =
        typeof props.label === 'string'
            ? props.label.replace(/^form-content:/, '')
            : props.label;
    const translated =
        typeof i18nKey === 'string' ? t(i18nKey, { placeholder: placeholderValue }) : i18nKey;
    const usesHtmlComponents =
        typeof translated === 'string' && HTML_COMPONENT_TAG.test(translated);

    return (
        <Alert
            key={props.input.name}
            scheme="information"
            role="alert"
            className="mt-6 ml-14 print-field w-fit"
        >
            <AlertText>
                {usesHtmlComponents ? (
                    <Trans
                        t={t}
                        i18nKey={i18nKey}
                        values={{ placeholder: placeholderValue }}
                        components={{ strong: <strong />, br: <br /> }}
                    />
                ) : (
                    translated
                )}
            </AlertText>
        </Alert>
    );
};
